// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as ReactDom from "react-dom";
import * as RouterUtils from "../../utils/RouterUtils.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.jsx";
import HomepageModuleCss from "./Homepage.module.css";

let classes = HomepageModuleCss;

let supportsTransitionApi = (typeof document.startViewTransition === 'function');

function Homepage(props) {
  return <div
    className={classes.root}
  >
    <div
      className={Styles.page.centered}
    >
      <header>
        <h1
          aria-label={"Check Beerk"}
          className={"text-center"}
        />
        <p>
          {"Pivní zápisník"}
        </p>
      </header>
      <main>
        <a
          className={Styles.button.sizeLarge}
          href={"/misto"}
          onClick={RouterUtils.handleLinkClick(() => {
            let navigate = () => RescriptReactRouter.push(`/misto#` + RouterUtils.fromHomepageHash);
            if (supportsTransitionApi) {
              document.startViewTransition(() => {
                ReactDom.flushSync(navigate);
              });
              return;
            } else {
              return navigate();
            }
          })}
        >
          {"Otevřít"}
        </a>
      </main>
    </div>
  </div>;
}

let make = Homepage;

export {
  classes,
  supportsTransitionApi,
  make,
}
/* classes Not a pure module */
